import loadable from '@loadable/component';

const HeaderLoadable = loadable(() => import(/* webpackChunkName: 'retailer-header' */ './Header'));

const Header = (props: any) => <HeaderLoadable {...props} />;

export default Header;
